import React, { memo, useMemo, useCallback, useState, useEffect } from "react";
import { RgbColorPicker } from "react-colorful";
import { RgbColor } from "../../ColorPicker/types";
import './index.scss'

type Props = {
  label: string,
  color: RgbColor,
  onChange: (color: RgbColor) => void
}
export const SettingColorInputComponent = memo((props: Props) => {
  const { label, color, onChange } = props;
  return (
    <div className='colorinput line'>
      <div className='left'>
        <span>{label}</span>
      </div>
      <div className='right'>
        <RgbColorPicker onChange={onChange} color={color} className="lucentsetcolor" />
      </div>
    </div>
  )
})
